import {useUserStore} from "@/app/shared/state/UserDataModule";
import {publicRegistrationRoute} from "@/app/public/public-routes";
import {computed, defineComponent, onMounted, ref} from "vue";
import {useKlipApiProxy} from "@/plugins/proxy-client";
import {PriceDto} from "@/api/klip-api.proxy";
import {useFormatting} from "@/composables/formatting";

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    props: {},
    setup() {
        const proxy = useKlipApiProxy();
        const {formatCurrency} = useFormatting();

        const isLoading = ref<boolean>(true);
        const linkKlip = ref<string>(import.meta.env.VITE_LINKS_KLIP);
        const linkMapRequest = ref<string>(import.meta.env.VITE_LINKS_CREATEMAPREQUEST);
        const linkMapRequestRules = ref<string>(import.meta.env.VITE_LINKS_MAPREQUESTRULES);
        const linkArchiveMapRequest = ref<string>(import.meta.env.VITE_LINKS_ARCHIVE);
        const linkKlipApp = ref<string>(import.meta.env.VITE_LINKS_KLIPAPPURL);
        const linkKlipLegal = ref<string>(import.meta.env.VITE_LINKS_KLIPLEGAL);
        const prices = ref<PriceDto>();
        const routePublicRegistrationRoute = computed(() => {
            return `${publicRegistrationRoute.path}#stap1`;
        });

        const linkLogin = computed((): string => {
            return "auth/login";
        });

        const smallAreaPriceWithVat = computed((): number => {
            if (!prices.value?.smallAreaPrice) return 0;
            return prices.value.smallAreaPrice * 1.21;
        });

        const largeAreaPriceWithVat = computed((): number => {
            if (!prices.value?.largeAreaPrice) return 0;
            return prices.value.largeAreaPrice * 1.21;
        });


        const imklWithVat = computed((): number => {
            if (!prices.value?.imklPrice) return 0;
            return prices.value.imklPrice * 1.21;
        });

        const loadPrices = async () => {
            prices.value = await proxy.home_Prices();
            isLoading.value = false;
        }

        onMounted(async () => {
            useUserStore().updateIsCheckingAuthentication(false);
            await loadPrices();
        });

        return {
            formatCurrency,
            linkKlip,
            linkMapRequest,
            linkMapRequestRules,
            linkArchiveMapRequest,
            linkKlipApp,
            linkKlipLegal,
            routePublicRegistrationRoute,
            linkLogin,
            prices,
            smallAreaPriceWithVat,
            largeAreaPriceWithVat,
            imklWithVat,
            isLoading
        };
    },
});
